import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

export const DetailsPageSkeleton = () => {
  return (
    <Stack gap={4}>
      <Stack>
        <Typography variant="h1">
          <Skeleton variant="text" sx={{ maxWidth: 400 }} />
        </Typography>
        <Typography>
          <Skeleton variant="text" sx={{ maxWidth: 300 }} />
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        <Grid size={4}>
          <Skeleton variant="rounded" height={250} />
        </Grid>
        <Grid size={4}>
          <Skeleton variant="rounded" height={250} />
        </Grid>
        <Grid size={4}>
          <Skeleton variant="rounded" height={250} />
        </Grid>
        <Grid size={8}>
          <Skeleton variant="rounded" height={300} />
        </Grid>
      </Grid>
    </Stack>
  );
};
